module.exports = __webpack_public_path__ + "img/47.b9cf2631.jpg";